<template>
  <div class="issueadd"  v-show="addShow">
    <div class="addTitle">
      <span>创建批注</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <notationAdd v-if="addShow" ref="notationAdd" type="rvt" @closeAdd = "closeAdd" />
    </div>
  </div>
</template>

<script>
import notationAdd from "@/views/question/notationAdd.vue";
export default {
  components:{notationAdd},
  data(){
    return{
      addShow:false,
    }
  },
  methods:{
    showAdd(){
      Monge.Model.Mark.clear();
      this.$message.success("请点击模型创建锚点");
      this.addShow= true;
      // this.$nextTick(()=>{
      //   this.$refs.notationAdd.init()
      // })
      // this.AddCloudNot()
    },
    closeAdd(logo){
      if(logo=='list'){//打开问题列表
        this.$parent.$refs.listNotation.openList()
        this.addShow= false;
      }else{
        this.addShow= false;
      }
    },
    closeArea(){
      Monge.Model.Mark.clear();
      Monge.Model.Mark.deactive()
      this.addShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.issueadd{
  position: absolute;
  top: 35px;
  right: 30px;
  width: 370px;
  height: calc(100% - 90px);
  max-height: 870px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: calc(100% - 50px);
    padding: 10px 0 10px 15px;
    overflow: hidden;
  }
}
</style>